<template>
    <Model :is-open="modelForm.is_open">
        <template #body>
            <div class="flex-grow">
                <div class="flex justify-between ">
                    <p class="text-lg font-medium ">Are your sure delete the Fees?</p>
                </div>
            </div>
        </template>
        <template #buttons>
            <div class="flex justify-end">
                <Button @click="modelForm.is_open=false"
                        class="bg-red-600 text-primary-light hover:!bg-red-300 hover:border-white mx-4">Cancel
                </Button>
                <Button @click="handleRemoveEMI()" class="mr-2">Delete</Button>
            </div>
        </template>
    </Model>
    <internal>
        <card-header
            :title="'Course Year: '+branchcourseyear.courseyear.title+' - '+branchcourseyear.courseyear.course.title"/>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <breeze-table :fields="fields" :items="coursefees"
                          :action="{'text':'add fee emi','url':route('internal.courseyear.fee.create',[branchid,branchcourseyear.id])}"
                          :canView="hasRole('View Branch Course')"
                          :canCreate="hasRole('Create Branch Course')">

                <template #status="data">
                    {{ data.item.status ? 'Active' : 'Inactive' }}
                </template>
                <template #action="data">
                    <button-link
                        v-if="hasRole('Edit Branch Course')"
                        :href="route('internal.courseyear.fee.edit',[branchid,branchcourseyear.id,data.item.id])">Edit
                    </button-link>
                    <Button @click="()=>{
                            modelForm.is_open=true;
                            modelForm.item=data.item;
                        }"
                            v-if="hasRole('Edit Branch Course')"
                            class="bg-red-600 text-primary-light hover:!bg-red-300 hover:border-white ml-2 translate-y-1">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             class="w-4 h-4  justify-self-center cursor-pointer"
                             viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd"
                                  d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                  clip-rule="evenodd"></path>
                        </svg>
                    </Button>
                </template>
            </breeze-table>
        </div>
    </internal>
</template>

<script>
import Internal from '@/Pages/Internal/Internal'
import BreezeTable from '@/Components/Table'
import ButtonLink from '@/Components/ButtonLink'
import CardHeader from '@/Components/CardHeader'
import Model from "@/Components/Model.vue";
import Button from "@/Components/Button.vue";
import {useForm} from "@inertiajs/inertia-vue3";
import {hasRole} from "../../../../Utils/checkPermission";

export default {
    components: {
        Button,
        Model,
        Internal,
        BreezeTable,
        ButtonLink,
        CardHeader
    },
    props: ['branchcourseyear', 'coursefees'],
    data() {
        return {
            fields: [{'key': 'title', 'label': 'Title'}, {'key': 'amount', 'label': 'Amount'}, {
                'key': 'end_date',
                'label': 'End Date'
            }, {'key': 'due_date', 'label': 'Due Date'}, {'key': 'status', 'label': 'Status'}, {
                'key': 'action',
                'label': 'Action'
            }],
            branchid: localStorage.branchId,
            modelForm: {
                is_open: false,
                item: {},
            },
            form: useForm({})
        }
    },
    methods: {
        hasRole,
        handleRemoveEMI() {
            this.form.post(route('internal.courseyear.fee.destroy', [this.branchid, this.branchcourseyear.id, this.modelForm.item.id]), {
                preserveScroll: true,
                onSuccess: () => {
                    this.modelForm.is_open = false;
                    this.form.reset();
                    location.reload()
                },
            });
        }
    }
}
</script>
